
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import VModal from 'vue-js-modal'


Vue.component('fake-artist', require('./components/FakeArtist.vue'));
Vue.use(VModal);

// Initialize Firebase
window.firebase = require('firebase');
firebase.initializeApp({
    apiKey: "AIzaSyCKfXvAUo5K4x6el58yx5Lc79NtqG2a4OE",
    databaseURL: "https://fake-artist-78731.firebaseio.com",
    projectId: "fake-artist-78731",
});

const app = new Vue({
    el: '#app'
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js